import { render, staticRenderFns } from "./MessageTab.vue?vue&type=template&id=988f02a4&scoped=true"
import script from "./MessageTab.vue?vue&type=script&lang=js"
export * from "./MessageTab.vue?vue&type=script&lang=js"
import style0 from "./MessageTab.vue?vue&type=style&index=0&id=988f02a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988f02a4",
  null
  
)

export default component.exports